<template>
   <Page>
     <div class="popup-code" :class="{show:codeIsShow}" @click="close">
       <div class="close" @click="close"><i class="el-icon-close"></i></div>
       <div class="code">
         <img src="https://reg.uniceramics.com.cn/assets/yanqi2022.jpg" alt="">
       </div>
     </div>
     <div class="slidebox" :style="{'background':'url('+banner[0].picture+') no-repeat','background-size':'100% 100%'}">
          <keep-alive include="slide"><Slide></Slide></keep-alive>
          <div class="wrap">
           <div class="center">
             <h2>{{$t('index.t1')}}</h2>
             <h4>产品展+装备材料展 同期举办</h4>
             <h4>2024年4月18-22日 </h4>
             <!-- <h4>{{$t('index.t22')}}</h4> -->
             <div class="btn-box mt40">
               <a :href="shareUrl" target="_bland"><Btn color="red" title="观展报名"></Btn></a>
             </div>
           </div>
         </div>
     </div>

     <Pane class="mt30" :title="$t('sidebar.d_news')">
       <div class="flexbox screen2">
         <div class="col">
           <div class="imgbtn"  v-if="lang==='zh'">
           </div>
           <div class="video-box" v-if="lang==='en'">
             <video controls="controls" src="http://www.uniceramics.com.cn/static/video/Uniceramics%20Expo%202020%20Review%20_%20Pro.mp4"></video>
           </div>
           <div class="article-list">
             <ul>
               <li v-for="(item,index) in news1" :key="index" v-if="item.title!=''">
                 <router-link :to="'/dynamic/detail/'+item.id" class="ell">{{item.title}}</router-link>
               </li>
             </ul>
           </div>
         </div>
 
         <div class="col">
           <div class="imgbtn" v-if="lang==='zh'">
           </div>
           <div class="video-box" v-if="lang==='en'">
             <video controls="controls" src="http://www.uniceramics.com.cn/static/video/Uniceramics%20Expo%202020%20Review%20_%20Tec.mp4"></video>
           </div>
           <div class="article-list">
             <ul>
               <li v-for="(item,index) in news2" :key="index" v-if="item.title!=''">
                 <router-link :to="'/dynamic/detail/'+item.id" class="ell">{{item.title}}</router-link>
               </li>
             </ul> 
           </div>
         </div>
       </div>
     </Pane>

     <Pane class="mt20" :title="$t('index.t5')">
       <ul class="flexbox screen4">
         <li v-for="(item,index) in museum" :key="index">
           <!-- <img src="@/assets/index/s301.jpg" alt=""> -->
           <div class="img-box">
             <img :src="item.picture" alt="">
             <div class="mask">
               <a :href="item.url" class="preview-detail mt20" target="_bland"><i class="el-icon-d-arrow-right"></i></a>
             </div>
             <a :href="item.url" class="mobile" target="_bland"></a>
           </div>
           <a :href="item.url" target="_bland">{{item.title}}</a>
         </li>
       </ul>
     </Pane>

     <!-- <div class="screen5">
       <div class="flexbox">
         <div>
           <h3 class="fs20 mb30" style="line-height:1.6vw;">2024佛山潭洲陶瓷展4月18日开幕，双展合一</h3>
           <P class="fs16 mb10">5月30日晚，万众期待的“全球陶瓷人佛山之夜”在佛山华夏明珠大酒店拉开帷幕。来自全球各地的600多位陶业人士齐聚一堂，畅想新时代下世界陶瓷的未来。</P>
           <P class="fs16  mb10">广东省建筑材料行业协会常务副会长、广东陶瓷协会会长陈环，意大利陶机及设备制造商协会执行董事Gian Paolo Crasta，越南陶瓷协会副会长阮明俊分别分享了中国、意大利、越南陶瓷产业的情况并提出发展建议。佛山陶瓷行业协会会长梁桐灿代表组委会宣布，2024佛山潭洲陶瓷展4月18-22日举行，产品展和装备材料展同期举办，展满5天。</P>
           <P class="fs16  mb10">【时间】2024年 4月18-22日</P>
           <P class="fs16  mb10">【展览范围】</P>
           <P class="fs16  mb10">1-5号馆：瓷砖、岩板、进口砖、地铺石、木纹砖、马赛克、软瓷、新型陶瓷材料等6-10号馆：压机、窑炉、球磨、数字布料、釉线、喷墨打印设备、色釉料、原材料、智能仓储、智能分拣、包装、AGV、岩板深加工等</P>
           <P class="fs16  mb10 mt20">地点：佛山顺德潭洲国际会展中心</P>
           <P class="fs16 mt20">参展联系：</P>
           <P class="fs16">15099861552（何小姐）</P>
           <P class="fs16 mb40">13580595381（李先生）</P>
           <router-link to="/dynamic/news"><Btn :title="$t('btn.more')"></Btn></router-link>
         </div>
         <div><img src="@/assets/index/s50102.jpg" alt="" /></div>
       </div>
     </div> -->

     <!-- <div class="screen6 mb40">
       <Title title="支持单位" color="black"></Title>
       <ul>
         <li v-for="(item,index) in support" :key="index">
           <a :href="item.url" target="_bland">
             <img :src="item.picture" :alt="item.title" />
           </a>
         </li>
       </ul>
     </div> -->
     <!-- <div class="screen6 mb40">
       <Title :title="$t('index.blogroll')" color="black"></Title>
       <Roll :list="flinks" :speed="124430" sname="flinksSwiper"></Roll>
     </div> -->

   </Page>
 </template>
 
 <script>
 import Page from '@/components/page.vue'
 import Btn from '@/components/Button/Btn.vue'
 import Title from '@/components/Title/title.vue'
 import Covid from '@/components/Title/title.vue'
 
 import Slide from './components/slide.vue'
 import Pane from './components/pane.vue'
 import Roll from './components/Roll.vue'
 import axios from 'axios'
 
 const slist3 = [{thumb:require('@/assets/index/s301.jpg'),title:'岩板+定制馆'},
 {thumb:require('@/assets/index/s302.jpg'),title:'岩板+定制馆'},
 {thumb:require('@/assets/index/s303.jpg'),title:'岩板+定制馆'}
 ]
 
 export default {
   name: 'index',
   components:{Page,Title,Btn,Slide,Pane,Roll,Covid},
   data(){
     return {
       slide_bg:'',
       slist3,
       covidTips:false,
       codeIsShow:false,
       bmcodesrc:require("@/assets/bmcode.gif"),
       shareUrl:"https://reg2024.uniceramics.com.cn/login?source=7",
       shareUrl2:"https://reg.uniceramics.com.cn/login?source=34&tp=2"
     }
   },
   created(){
     this.$store.dispatch('index/getBanner');
     this.$store.dispatch('index/getNews1');
     this.$store.dispatch('index/getNews2');
     this.$store.dispatch('index/getActivity');
     this.$store.dispatch('index/getFlinks');
     this.$store.dispatch('index/getSupport');
     this.$store.dispatch('index/getMuseum');
     // console.log('index created');
   },
   mounted(){
     const source = this.$route.query.source;
     let url = "https://admin.uniceramics.com.cn/api/census"
     if(typeof source!=='undefined'){
       url+="/"+source
     }
     axios.get(url);
     if(source==='560'){
       // this.bmcodesrc = "http://www.uniceramics.com.cn/2021/bm2021-baidu.png";
       this.shareUrl="https://reg.uniceramics.com.cn/login?source=560";
     }
     //110
     // if(source==='sougou'){
     //   // this.bmcodesrc = "http://www.uniceramics.com.cn/2021/bm2021-sougou.png";
     //   this.shareUrl="https://reg.uniceramics.com.cn/login?source=110";
     // }
   },
   activated(){
     console.log('index activated');
   },
   computed:{
     banner(){return this.$store.state.index.banner},
     news1(){return this.$store.state.index.news1},
     news2(){return this.$store.state.index.news2},
     activity(){return this.$store.state.index.activity},
     flinks(){return this.$store.state.index.flinks},
     support(){return this.$store.state.index.support},
     lang(){return this.$store.state.index.lang},
     museum(){return this.$store.state.index.museum}
   },
   watch:{
     banner:function(val){
       this.slide_bg = val[0].picture;
       console.log("slide watch");
     }
   },
   methods:{
     opencode(){
       this.codeIsShow = true;
     },
     close(e){
       if(e.target.tagName!='IMG'){
         this.codeIsShow = false;
       }
     }
   }
 }
 </script>
 
 <style scoped>
 
 /* .popup-code{visibility: hidden; position: fixed; z-index:9999; top:0; bottom:0; left:12.5%; right:0; background:rgba(0,0,0,0); transition-duration: 300ms; display:flex;}
 .popup-code.show{visibility: visible; background:rgba(0,0,0,.7);}
 .popup-code .close{position: absolute; right: 1.5vw; top: 1.2vw;font-size: 2vw;color: #fff; cursor: pointer;-webkit-transition: all .5s;transition: all .5s; z-index: 10;}
 .popup-code .close:hover{transform: rotate(90deg);}
 .popup-code .code{text-align:center; width:20vw; height:20vw; margin:auto; opacity:0; transition-duration:300ms;}
 .popup-code .code::after{content:'扫描二维码报名';color:#fff; font-size:1.5vw; display:inline-block; margin-top:0.5vw;}
 .popup-code .code img{width:20vw; display:block; }
 .popup-code.show .code{opacity:1;} */
 
 .popup-code{visibility: hidden; position: fixed; z-index:9999; top:0; bottom:0; left:12.5%; right:0; background:rgba(0,0,0,0); transition-duration: 300ms; display:flex;}
 .popup-code.show{visibility: visible; background:rgba(0,0,0,.7);}
 .popup-code .close{position: absolute; right: 1.5vw; top: 1.2vw;font-size: 2vw;color: #fff; cursor: pointer;-webkit-transition: all .5s;transition: all .5s; z-index: 10;}
 .popup-code .close:hover{transform: rotate(90deg);}
 .popup-code .code{text-align:center; width:32vw;  margin:auto; opacity:0; transition-duration:300ms;}
 /* .popup-code .code::after{content:'扫描二维码报名';color:#fff; font-size:1.5vw; display:inline-block; margin-top:0.5vw;} */
 .popup-code .code img{width:32vw; display:block; }
 .popup-code.show .code{opacity:1;}
 .slidebox{height:43.25vw; position: relative; overflow:hidden;}
 .slidebox>.wrap{display:flex; justify-content: center; align-items: center; position: absolute; top:0;bottom:0; left:0; right:0; background:rgba(0,0,0,0.5); color:#fff;}
 .slidebox>.wrap h2{font-size: 4.29166667vw; color: #fff; font-weight: 500; margin-bottom: 1.50905vw; text-align: center;}
 .slidebox>.wrap h4{font-size:2.41591vw; font-weight: 500; text-align: center; margin-bottom:0.6211vw;}
 .slidebox>.wrap h4:nth-of-type(2){margin-bottom:2.5211vw;}
 .slidebox>.wrap .btn-box{ display:flex; justify-content: center;}
 .slidebox>.wrap .btn-box .main-button{margin:0 0.8vw; width:14vw; height:3.5vw;}
 /* .slidebox>.wrap .btn-box a:nth-of-type(2) .main-button{margin:0 1vw; width:17vw; height:3.5vw;} */
 .slidebox>.wrap .btn-box a .main-button{margin:0 1vw; width:17vw; height:3.5vw;}
 .flexbox{display: flex;}
 .screen2{color:#fff; justify-content: space-between; padding:1.2vw 1.4vw;}
 .screen2 .col .imgbtn{width:32.526312vw; height:15.7895vw; background:url(../../assets/index/btnbg01.jpg) no-repeat; background-size:100% 100%;}
 .screen2 .col .imgbtn{box-sizing: border-box;/* padding-left:15.5895vw; padding-top:4.47368vw;*/}
 .screen2 .col .imgbtn h3{font-size:1.36vw; margin-bottom:3.1vw;}
 .screen2 .col .article-list li{width:32.526312vw; height:3.42vw; line-height:3.42vw; font-size:0.9vw; border-bottom:1px solid #eee;}
 .screen2 .col .article-list li>a{display:block; color:#000; transition-duration: 300ms;}
 .screen2 .col .article-list li>a:hover{display:block; color:#c72a27;}
 .screen2 .col:nth-of-type(2) .article-list li>a:hover{color:#1a3eb3;}
 .screen2 .col:nth-of-type(2) .imgbtn{background:url(../../assets/index/btnbg02.jpg) no-repeat; background-size:100% 100%;}
 
 .screen2 .col .video-box>video{width:32.526312vw; height:18.5vw;}
 
 .screen3 .title-box{margin:3vw 0 1.5vw 6.23428859vw}
 .screen3 ul{display: flex; flex-wrap: wrap; justify-content: space-between;}
 .screen3 li{display:block; width:28.42vw; height:16.21vw; position: relative; margin-bottom:0.9vw;}
 .screen3 li img{width:100%; height:100%;}
 .screen3 li .mask,
 .screen4 li .mask
 {position:absolute; width: 100%; height: 100%;top:0; left:0;opacity: 0;background: #fff; transition-duration: 300ms;
   display:flex; flex-direction: column; align-items: center;justify-content: center;}
 .screen3 li .mask .preview-detail,
 .screen4 li .mask .preview-detail
 {width: 2.29166667vw;height: 2.29166667vw;background: #d70e19;border-radius: 50%;display: flex;justify-content: center;align-items: center;font-size: 1.04166667vw;color: #fff;}
 .screen3 li:hover .mask,
 .screen4 li:hover .mask
 {opacity: .95;}
 
 .screen3 li .mask div{transition-duration: 400ms; opacity:0; transform: translateY(-10px);}
 .screen3 li .mask .preview-detail{transition-duration: 400ms; opacity:0; transform: translateY(10px);}
 .screen3 li:hover .mask div{opacity:1; transform: translateY(0);}
 .screen3 li:hover .mask .preview-detail{opacity:1; transform: translateY(0);}
 .screen4{color:#fff; justify-content: space-between; padding:1.2vw 1.4vw;}
 .screen4 li{display:block; position: relative; margin-bottom:0.9vw;}
 .screen4 li .img-box{width:21.58vw; height:21.58vw; position: relative;}
 .screen4 li .img-box img{width:100%; height:100%;}
 .screen4 li .img-box .mask .preview-detail{width: 2.5vw;height: 2.5vw; transform: scale(.6); opacity:0; transition-duration:400ms;}
 .screen4 li:hover .img-box .mask .preview-detail{transform: scale(1); opacity:1;}
 .screen4 li>a{display:block; color:#333; margin:0.5vw 0; font-size:0.947368vw;}
 .screen5 .title-box{margin:3vw 0 1.5vw 6.23428859vw}
 .screen5 .flexbox{justify-content: space-between; padding:0 6.23428859vw;}
 .screen5 .flexbox div:nth-of-type(1){width:37.9vw;}
 .screen5 .flexbox div:nth-of-type(1) h3{margin-top:5vw;}
 .screen5 .flexbox div:nth-of-type(1) p{line-height:1.5vw;}
 
 .screen5 .flexbox div:nth-of-type(2){width:29vw; height:17vw; margin:5vw 0 0 0;}
 .screen5 .flexbox div:nth-of-type(2) img{width:100%; height:100%;}
 .screen5 .hack{line-height:1.5vw;}
 
 .screen6 .title-box{margin:3vw 0 1.5vw 6.23428859vw}
 .screen6 ul{display:flex; flex-wrap:wrap; margin:1vw 0 1.5vw 6.23428859vw}
 .screen6 ul li{margin-right:1vw; margin-bottom:0.6vw;}
 .screen6 ul li a{display:block;}
 .screen6 ul li a img{height:2.6vw;}
 .screen6 ul li a span{display:block; text-align: center; font-size:1vw;}
 
 
 .contact-box{font-size:1.4vw; text-align: center; margin-top:1vw;}
 .contact-box div:nth-of-type(1){margin:2vw 0 0.5vw 0;}
 .contact-box div:nth-of-type(2),.contact-box div:nth-of-type(3){ line-height:2.2vw;font-weight: bold;}
 @media (max-width: 991px){
 /* .popup-code{left:0;top:55px;}
 .popup-code .close{font-size:7vw;}
 .popup-code .code{width:60vw; height:60vw;}
 .popup-code .code img{width:60vw;}
 .popup-code .code::after{content:'长按二维码进入报名';color:#fff; font-size:4vw; display:inline-block; margin-top:1vw;} */
 
 .popup-code{left:0;top:55px;}
 .popup-code .close{font-size:7vw;}
 .popup-code .code{width:85vw;}
 .popup-code .code img{width:85vw;}
 /* .popup-code .code::after{content:'长按二维码进入报名';color:#fff; font-size:4vw; display:inline-block; margin-top:1vw;} */
 .slidebox{height:50vw;}
 .slidebox>.wrap h2{font-size: 4.8vw;  margin-bottom: 1.5vw;}
 .slidebox>.wrap h4{font-size:2.9vw; margin-bottom:1vw;}
 .slidebox>.wrap h4:nth-of-type(2){margin-bottom:3vw;}
 .slidebox>.wrap .btn-box .main-button{margin:0 3vw; width:24vw; height:8vw;}
 .slidebox>.wrap .btn-box a .main-button{margin:0 3vw; width:32vw; height:8vw;}
 .screen2{padding:2.5vw 2.42vw; flex-wrap: wrap;}
 .screen2 .col{margin-bottom:5vw;}
 .screen2 .col .imgbtn{width:90vw; height:44vw; /*padding-left:43vw; padding-top:12vw;*/}
 .screen2 .col .imgbtn h3{font-size:4vw; margin-bottom:7.5vw;}
 .screen2 .col .article-list li{width:90vw; height:10vw; line-height:10vw; font-size:3.2vw; border-bottom:1px solid #eee;}
 .screen2 .col .video-box>video{width:90vw; height:50.5vw;}
 
 .screen3 .title-box{margin:2vw 0 2.5vw 6.23428859vw}
 .screen3 ul{justify-content: space-around;}
 .screen3 li{width:48vw; height:24.3vw; margin-bottom:1.6vw;}
 .screen3 li .mobile,.screen4 li .mobile{position:absolute; width: 100%; height: 100%;top:0; left:0;opacity: 0;}
 .screen3 li .mask,.screen4 li .mask{display:none;}
 
 .screen4 li .img-box{width:29.5vw; height:29.5vw;}
 .screen4 li>a{margin:1vw 0; font-size:3.2vw;}
 
 .screen5 .flexbox div:nth-of-type(1){width:92vw;}
 .screen5 .flexbox div:nth-of-type(1) p{line-height:4.5vw;}
 .screen5 .flexbox div:nth-of-type(2){display: none;}
 .screen5 .flexbox .mb100{margin-bottom:8vw;}
 .screen5 .fs20{font-size:3.8vw; line-height:3.8vw;}
 .screen5 .fs16{font-size:3.2vw; line-height:3.2vw;}
 .screen5 .hack{line-height:4vw;}
 .screen6 .title-box{margin:8vw 0 4vw 6.23428859vw}
 .screen6 ul{display:flex; flex-wrap:wrap; justify-content: space-around; margin:1vw 0 1.5vw 6.23428859vw; flex-wrap: wrap;}
 .screen6 ul li{margin-right:2vw; margin-bottom:2vw;}
 .screen6 ul li a{display:block;}
 .screen6 ul li a img{height:7vw;}
 .screen6 ul li a span{display:block; text-align: center; font-size:3vw;}
 
 .contact-box{font-size:3vw; text-align: center; margin-top:1vw;}
 .contact-box div:nth-of-type(1){margin:3vw 0 0.5vw 0;}
 .contact-box div:nth-of-type(2),.contact-box div:nth-of-type(3){ line-height:4.5vw;font-weight: bold;}
 }
 </style>
 
 <style type="text/css">
   .slidebox>.wrap .btn-box .main-button .text span{font-size:1.5vw; font-weight: bold;}
   .slidebox>.wrap .btn-box .main-button .text i{font-size:1.5vw;}
 @media (max-width: 991px){
   .slidebox>.wrap .btn-box .main-button .text span{font-size:1.8vw;}
   .slidebox>.wrap .btn-box .main-button .text i{font-size:1.8vw;}
 }
 </style>
 